/**
 * Internacionalización mínima sin dependencias: claves con punto,
 * interpolación {nombre} y formatos con Intl.
 */
import { createContext, useContext, useMemo, type ReactNode } from 'react';
import { es, type Messages } from './es';
import { en } from './en';

export { capitalize, LOCALES, makeT, type Locale, type TFn } from '@habitos/assistant/i18n/core';
import { capitalize, makeT, type Locale, type TFn } from '@habitos/assistant/i18n/core';

const catalogs: Record<Locale, Messages> = { es, en };

export function detectLocale(): Locale {
  const lang = (typeof navigator !== 'undefined' ? navigator.language : 'es').toLowerCase();
  return lang.startsWith('en') ? 'en' : 'es';
}


interface I18nValue {
  locale: Locale;
  t: TFn;
  m: Messages;
  tag: string;
  fmtNumber: (n: number) => string;
  fmtDate: (d: string, opts?: Intl.DateTimeFormatOptions) => string;
}

const I18nContext = createContext<I18nValue | null>(null);

export function I18nProvider({ locale, children }: { locale: Locale; children: ReactNode }) {
  const value = useMemo<I18nValue>(() => {
    const tag = locale === 'es' ? 'es-ES' : 'en-US';
    const nf = new Intl.NumberFormat(tag, { maximumFractionDigits: 2 });
    return {
      locale,
      t: makeT(locale),
      m: catalogs[locale],
      tag,
      fmtNumber: (n) => nf.format(n),
      fmtDate: (d, opts = { day: 'numeric', month: 'long' }) =>
        capitalize(new Intl.DateTimeFormat(tag, { ...opts, timeZone: 'UTC' }).format(new Date(`${d}T12:00:00Z`))),
    };
  }, [locale]);
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n(): I18nValue {
  const v = useContext(I18nContext);
  if (!v) throw new Error('I18nProvider ausente');
  return v;
}
